import React, { FC } from 'react';

import loading from '../../../assets/images/svg/loading.svg';
import { Button } from '../../common';
import { PrimaryButtonColor } from '../../common/buttons/decorators/PrimaryButton/PrimaryButton';
import { PrimaryButton } from '../../index';
import styles from './OnboardingMobileFooter.module.scss';

interface OnboardingMobileFooterProps {
  handleNextStep: () => void;
  validateCurrentStep: () => boolean;
  currentStep: number;
  stepsCount: number;
  isLoading?: boolean;
}

const OnboardingMobileFooter: FC<OnboardingMobileFooterProps> = ({
  handleNextStep,
  validateCurrentStep,
  currentStep,
  stepsCount,
  isLoading = false,
}) => {
  return (
    <div className={styles.onboardingMobile__footer}>
      <div className={styles.paginator}>
        {Array.from({ length: stepsCount }).map((_, index) => (
          <div
            key={index}
            className={`${styles.paginatorDot} ${
              currentStep === index ? styles['paginatorDot--active'] : ''
            }`}
          ></div>
        ))}
      </div>
      <PrimaryButton
        color={!validateCurrentStep() ? PrimaryButtonColor.GRAY : PrimaryButtonColor.GREEN}
        className={styles.nextButton}
        expanded={true}
        disabled={!validateCurrentStep()}
      >
        <Button onClick={handleNextStep} disabled={!validateCurrentStep()}>
          {isLoading ? (
            <>
              <img src={loading} alt={'Загрузка...'} />{' '}
            </>
          ) : (
            'Дальше'
          )}
        </Button>
      </PrimaryButton>
    </div>
  );
};

export default OnboardingMobileFooter;
